import { useEffect, useState } from 'react';

const themeCssPath = (isRTL) => `${process.env.PUBLIC_URL}/css/theme${isRTL ? '.rtl' : ''}.css`;
const userCssPath = (isRTL) => `${process.env.PUBLIC_URL}/css/user${isRTL ? '.rtl' : ''}.css`;

const hasStylesheet = (path) =>
	Array.from(document.querySelectorAll('link[rel="stylesheet"]')).some((link) => {
		const href = link.getAttribute('href') || '';
		return href === path || href.endsWith(path) || link.href?.endsWith(path);
	});

const useToggleStylesheet = (isRTL, isDark) => {
	const [isLoaded, setIsLoaded] = useState(() => hasStylesheet(themeCssPath(isRTL)));

	useEffect(() => {
		document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');

		const themePath = themeCssPath(isRTL);
		const userPath = userCssPath(isRTL);

		// index.html 已挂同套 theme/user.css 时，勿卸掉再等 onload，否则刷新会短暂全屏遮罩（看起来像黑屏）
		if (hasStylesheet(themePath)) {
			setIsLoaded(true);
			return undefined;
		}

		setIsLoaded(false);
		Array.from(document.getElementsByClassName('theme-stylesheet')).forEach((link) => link.remove());

		const link = document.createElement('link');
		link.href = themePath;
		link.type = 'text/css';
		link.rel = 'stylesheet';
		link.className = 'theme-stylesheet';

		const userLink = document.createElement('link');
		userLink.href = userPath;
		userLink.type = 'text/css';
		userLink.rel = 'stylesheet';
		userLink.className = 'theme-stylesheet';

		link.onload = () => {
			setIsLoaded(true);
		};
		link.onerror = () => {
			setIsLoaded(true);
		};

		document.head.appendChild(link);
		document.head.appendChild(userLink);
		return undefined;
	}, [isRTL]);

	useEffect(() => {
		document.documentElement.setAttribute('data-bs-theme', isDark ? 'dark' : 'light');
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { isLoaded };
};

export default useToggleStylesheet;
